var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBaby(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.62 7.81a7.2 7.2 0 0 0-5.26-4.24l1.05-1.68-1.06-.66-1.38 2.2a7.2 7.2 0 0 0-6.59 4.38 2.81 2.81 0 0 0 0 5.63 7.19 7.19 0 0 0 13.24 0 2.81 2.81 0 0 0 0-5.63m1.06 3.9c-.29.3-.68.47-1.09.48l-.8.01-.32.75a5.94 5.94 0 0 1-10.94 0l-.31-.75-.81-.01a1.56 1.56 0 0 1 0-3.13l.8-.01.32-.75a5.94 5.94 0 0 1 10.94 0l.31.75.81.01a1.56 1.56 0 0 1 1.09 2.66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.13 9.06H6.56v1.56h1.57zM13.44 9.06h-1.56v1.56h1.56zM10 15a3.1 3.1 0 0 0 3.13-3.12H6.87A3.13 3.13 0 0 0 10 15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBaby);
export default ForwardRef;